import axios from 'axios';

const LOCAL_SERVICES = {
 
  payment: 'http://localhost:1000',
};

const LIVE_URL = process.env.REACT_APP_LIVE_URL;

const getBaseURL = (service) => {
  if (process.env.NODE_ENV === 'production') {
    return LIVE_URL;
  }
  return LOCAL_SERVICES[service] ;
};

const createAxiosInstance = (service) => {
  const baseURL = getBaseURL(service);

  const axiosInstance = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  axiosInstance.interceptors.request.use((config) => {
    const user = JSON.parse(localStorage.getItem('user')) || {};

    if (process.env.NODE_ENV === 'production') {
      config.headers['Authorization'] = `Bearer ${user._token}`;
    } else {
      config.headers['x-s4o-role'] = 'user';
      config.headers['x-s4o-user'] = user._id;
      config.headers['x-s4o-permissions'] =
        'order:read:any,order:create:any, order:update:any,payment:create:any,payment:read:any,subscriber:read:any, subscriber:update:any, subscriber:create:any, subscriptionPlan:read:any, subscriptionPlan:update:any, subscriptionPlan:create:any, wallet:read:any, wallet:create:any, wallet:update:any,user:read:any,user:create:any, user:update:any, transaction:read:any, transaction:update:any, transaction:create:any';
    }

    return config;
  });

  return axiosInstance;
};

export default createAxiosInstance;
